export function getValueByPath(o: any, path: string, fb: any = null) {
  if (!o || !path) return fb;
  return path.split('.').reduce((o, p) => o && typeof o !== 'string' && o.hasOwnProperty(p) ? o[p] : fb, o);
}
